import React from "react";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export function TopBottomScrollButton() {
  const goToTop = () => {
    document.documentElement.style.overflow = "auto";
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goToBottom = () => {
    document.documentElement.style.overflow = "auto";
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="scroll-buttons " style={{ position: "fixed", bottom: "30px", zIndex: "10000000", left: "10px" }}>
        <div>
          <button onClick={goToTop} className="btn btn-primary mb-1 btn-sm px-2" aria-label="Scroll to top">
            <ArrowUpIcon />
          </button>
        </div>

        <div>
          <button onClick={goToBottom} className="btn btn-primary btn-sm  px-2" aria-label="Scroll to bottom">
            <ArrowDownIcon />
          </button>
        </div>
      </div>
    </>
  );
}
